import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Layout, Button } from 'antd'
import Translate from 'react-translate-component';
import cx from 'classnames';

import { sidebarClose } from 'actions/sidebarActions';
import SidebarSwitcher from './SidebarSwitcher';

import SidebarHeader from 'components/sidebars/SidebarHeader';
import CatchError from 'components/common/CatchError';

const SidebarError = ({ reset }) => (
    <div>
        <SidebarHeader />
        <div className="catched-error">
            <Translate content="errors.couldNotOpenSidebar" component="h3" className="m-b-15 m-t-20" />
            <Button type="blue" onClick={reset}>
                <Translate content="common.refresh" />
            </Button>
        </div>
    </div>
);

const renderOnError = (reset) => <SidebarError reset={reset} />;

const stateToProps = ({ sidebar }) => ({
    sidebar
});

@connect(stateToProps, { sidebarClose })
export default class Sidebar extends Component {
    static propTypes = {
        sidebarClose: PropTypes.func.isRequired,
        sidebar: PropTypes.object.isRequired,
        additionalClass: PropTypes.string
    };

    render() {
        const { sidebar, sidebarClose, additionalClass } = this.props;

        return (
            <Layout.Sider
                trigger={null}
                collapsible
                collapsed={!sidebar.opened}
                collapsedWidth={0}
                width={499}
                className={cx("right-sidebar-fixed", additionalClass)}
            >
                <CatchError renderOnError={renderOnError} reset={!sidebar.opened}>
                    { sidebar.opened && <SidebarSwitcher {...sidebar} sidebarClose={sidebarClose} /> }
                </CatchError>
            </Layout.Sider>
        );
    }
}
